import { useSelector } from 'react-redux';

import {
  CurrencyDetails,
  MenuEditorSettings,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProvider/apis';
import { ProviderPermissions } from '@provider-portal/common/services/types/account';
import type { Nullable } from '@provider-portal/common/types/types';

import { selectSelectedProvider } from 'rdx/account';
import { LocaleType } from 'utils/translations';

export interface SelectedProvider {
  providerId: number;
  providerName: string;
  vendorName: string;
  cityId: number;
  countryCode: string;
  currency: CurrencyDetails;
  city_locales: LocaleType[];
  permissions: ProviderPermissions;
  menuEditorSettings?: MenuEditorSettings;
}

export function useSelectedProvider(): Nullable<SelectedProvider> {
  const selectedProvider = useSelector(selectSelectedProvider);
  return selectedProvider ?? null;
}

export function useSelectedProviderId(): Nullable<number> {
  const selectedProvider = useSelectedProvider();
  return selectedProvider?.providerId || null;
}

export function useSelectedProviderCurrency(): Nullable<CurrencyDetails> {
  const selectedProvider = useSelectedProvider();
  return selectedProvider?.currency || null;
}

export function useSelectedProviderMenuEditorSettings(): Nullable<MenuEditorSettings> {
  const selectedProvider = useSelectedProvider();
  return selectedProvider?.menuEditorSettings || null;
}
